import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../../assets/img/logo-nanny.png";
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchForgotpasdAsync } from '../../../store/apiSlice/ForgotpasswordSlice';
import { ClipLoader } from 'react-spinners';
import { forgotPasswordVerifyOtp } from '../../../store/apiSlice/ForgotPasswordOtpVerifySlice';
import { resetPasswordApi } from '../../../store/apiSlice/ResetPasswordSlice';
import { toast } from 'react-toastify';
import { clearData as resetForgotOtp } from '../../../store/apiSlice/ForgotpasswordSlice';
import { clearOtpData as resetVerifyOtp } from '../../../store/apiSlice/ForgotPasswordOtpVerifySlice';
import { clearData as resetResetPassword } from '../../../store/apiSlice/ResetPasswordSlice';


const Forgotpassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sendOtpResponse = useSelector((state) => state.rootReducer.Forgotpasd.data);
    const verifyOtpResponse = useSelector((state) => state.rootReducer.forgotPasswordOTP.data);
    const resetPasswordResponse = useSelector((state) => state.rootReducer.resetPassword.data);

    const [email, setEmail] = useState('');
    const [step, setStep] = useState(1); // 1: send OTP, 2: verify OTP, 3: reset password
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showconfirmPassword, setShowconfirmPassword] = useState(false);
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);

    const handleBtnClick = () => {
        if (step === 1) {
            handleSendOTP()
        } else if (step === 2) {
            handleVerifyOTP()
        } else if (step === 3) {
            handleResetPassword()
        }
    };

    const handleSendOTP = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        const isValidEmail = emailRegex.test(email);
        if (!email || !isValidEmail) {
            alert('Please enter a valid email!')
            return
        }
        const payload = {
            email: email
        }
        setLoading(true)
        dispatch(fetchForgotpasdAsync(payload));
    };

    const handleVerifyOTP = () => {
        if (!otp) {
            alert("Please enter OTP.");
            return;
        }
        const payload = {
            email: email,
            otp: otp
        }
        setLoading(true)
        dispatch(forgotPasswordVerifyOtp(payload));
    };

    const handleResetPassword = () => {
        if (!email || !password || !confirmPassword) {
            alert('Please fill all fields!')
            return
        }
        if (password !== confirmPassword) {
            alert('Passwords do not match!');
            return;
        }
        if (password.length < 6) {
            alert('Password must be at least 6 characters.');
            return;
        }
        const payload = {
            email: email,
            password: password
        }
        setLoading(true)
        dispatch(resetPasswordApi(payload));
    };

    useEffect(() => {
        setLoading(false);
        if (sendOtpResponse) {
            if (sendOtpResponse.status === 1) {
                toast.success("OTP sent successfully!");
                setStep(2);
            } else {
                toast.error(sendOtpResponse.message || "Failed to send OTP!");
            }
        }
    }, [sendOtpResponse]);

    useEffect(() => {
        setLoading(false);
        if (verifyOtpResponse) {
            if (verifyOtpResponse.status === 1) {
                toast.success("OTP verified successfully!");
                setStep(3);
            } else {
                toast.error(verifyOtpResponse.message || "Invalid OTP!");
            }
        }
    }, [verifyOtpResponse]);

    useEffect(() => {
        setLoading(false);
        if (resetPasswordResponse) {
            if (resetPasswordResponse.status === 1) {
                toast.success("Password changed successfully!");
                navigate('/login');
                window.location.reload();
            } else {
                toast.error(resetPasswordResponse.message || "Password reset failed!");
            }
        }
    }, [resetPasswordResponse, navigate]);

    useEffect(() => {
        return () => {
            dispatch(resetForgotOtp());
            dispatch(resetVerifyOtp());
            dispatch(resetResetPassword());
        };
    }, [dispatch]);


    return (
        <div className="container-fluid ">
            <div className="row">
                <div className="container py-5">
                    <div className="custom-logo d-block login-logo mx-auto">
                        <img className="mw-100" src={logo} alt="logo" />
                    </div>
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3 offset-sm-1 col-sm-10">
                            <div className="login-container">
                                <form className="login-form m-2" appearance="outline">
                                    <h3 className='mb-3'>Forgot password</h3>

                                    {step === 1 && <div className='input-group'>
                                        <input
                                            type="text"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter your email"
                                        />
                                    </div>}

                                    {step === 2 && <div className='input-group'>
                                        <input
                                            type="number"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                            placeholder="Enter your  OTP"
                                        />
                                    </div>}

                                    {step === 3 && <div className='input-group'>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            placeholder="Enter your password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <span
                                            className="position-absolute end-0 top-50 translate-middle-y me-3"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? (
                                                <i className="fa fa-eye-slash" style={{ color: "#89d6ce" }}></i>
                                            ) : (
                                                <i className="fa fa-eye" style={{ color: "#89d6ce" }}></i>
                                            )}
                                        </span>
                                    </div>}

                                    {step === 3 && <div className='input-group'>
                                        <input
                                            type={showconfirmPassword ? "text" : "password"}
                                            id="password"
                                            placeholder="Enter your confirm password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                        <span
                                            className="position-absolute end-0 top-50 translate-middle-y me-3"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowconfirmPassword(!showconfirmPassword)}
                                        >
                                            {showconfirmPassword ? (
                                                <i className="fa fa-eye-slash" style={{ color: "#89d6ce" }}></i>
                                            ) : (
                                                <i className="fa fa-eye" style={{ color: "#89d6ce" }}></i>
                                            )}
                                        </span>
                                    </div>}

                                    <Button type='button' onClick={handleBtnClick} disabled={loading}>
                                        {loading ? (
                                            <ClipLoader color="#fff" size={16} />
                                        ) : (
                                            step === 1 ? 'Send OTP' : step === 2 ? 'Verify OTP' : 'Reset Password'
                                        )}
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default Forgotpassword
